<template>
  <pop-container :show="show">
    <div class="redeem-code font-demi" slot="content">
      <div
          class="img"
          v-lazy:background-image="lazyImgObj(config.imgUrl)"
          v-show="!showCode"
          @click="showRedeemCode"
          :alt="gettext('运营活动')"></div>
      <div :class="`redeem-bg-wrapper ${redeemBgAnimation} animated`" v-show="showCode && !loading">
        <div :class="`redeem-content ${redeemContentAnimation} animated-content`">
          <p class="label">{{gettext('兑换优惠券')}}</p>
          <p class="code">{{config.code}}</p>
        </div>
        <!-- 成功 -->
        <div :class="`redeem-suc-content ${redeemResAnimation} animated-res`" v-show="redeemResult==SUCC_CODE">
          <i class="success-icon"></i>
          <p class="title">{{gettext('兑换成功')}}</p>
          <p class="label font-regular">{{successText}}</p>
        </div>
        <!-- 失败 -->
        <div :class="`redeem-err-content ${redeemResAnimation} animated-res`" v-show="redeemResult==ERR_CODE && !networkErr">
          <i class="error-icon"></i>
          <p class="title">{{gettext('兑换失败')}}</p>
          <p class="label font-regular">{{errResult}}</p>
        </div>
        <div :class="`redeem-err-content network-err ${redeemResAnimation} animated-res`" v-show="redeemResult==ERR_CODE && networkErr">
          <p class="label font-regular">{{errResult}}</p>
        </div>
        <div class="redeem-red-front">
          <p :class="`${redeemResult==0 ? '' : 'fadeOut'} animated`">{{gettext('兑换中')}}</p>
          <loading :class="`${redeemResult==0 ? '' : 'fadeOut'} animated`" loadType="primary"></loading>
          <button class="btn fadeIn animated-res" v-show="redeemResult==SUCC_CODE" @click="handleJump">{{gettext('去看看')}}</button>
          <button class="btn fadeIn animated-res" v-show="redeemResult==ERR_CODE  && !networkErr" @click="handleJump">{{gettext('我知道了')}}</button>
          <button class="btn fadeIn animated-res" v-show="redeemResult==ERR_CODE  && networkErr" @click="tryRedeemCode">{{gettext('重试')}}</button>
        </div>
        <div class="redeem-red-back"></div>
      </div>
      <div class="close-btn" v-if="!loading">
        <img src="https://img0.didiglobal.com/static/soda_static/m/act/static/img/close_icon.png" @click="handleHide()">
      </div>
    </div>
  </pop-container>
</template>
<script>
import PopContainer from '@/components/pop-container'
import Loading from '@/components/loading/loading.vue'
import { util } from '@didi/soda-common'
import { sprintf } from '@didi/gettext'
import * as Api from '@/page/banner/store/api'
import trackEvent from '@/common/js/track'

const { env } = util
const SUCC_CODE = 1
const ERR_CODE = 2
const couponType = {
  DISCOUNT: 100,
  AMOUNT: 3
}

export default {
  name: 'promo-code',
  data () {
    return {
      show: true,
      redeemResult: 0,
      showCode: false,
      couponList: [],
      errResult: '',
      networkErr: false,
      ERR_CODE: ERR_CODE,
      SUCC_CODE: SUCC_CODE,
      imgLoadingTime: 0, // 图片加载时间
      isImgLoaded: false // 图片是否已执行加载完成
    }
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  components: {
    PopContainer,
    Loading
  },
  async mounted () {
    trackEvent({
      eventId: 'sailing_c_x_prom_window_sw',
      eventLabel: '兑换码活动弹窗展示',
      attrs: {
        activity_id: this.config.activityId
      }
    })
    this.imgLoadingTime = new Date().getTime()
    let globalParams = await this.SodaBridge('getGlobalParams', 'badcase') || {}
    const {osType, osVersion} = globalParams.data
    if (+osType === 2 && +osVersion.split('.')[0] < 6) { // 安卓 6.0 以下的系统无法监听到lazyload事件
      this.$emit('onHideLoad', { imgLoadingTime: new Date().getTime() - this.imgLoadingTime })
    } else {
      this.$Lazyload.$on('loaded', () => {
        if (!this.isImgLoaded) {
          this.$emit('onHideLoad', { imgLoadingTime: new Date().getTime() - this.imgLoadingTime })
        }
        this.isImgLoaded = true
      })
    }
    await this.setUserInfo()
  },
  computed: {
    redeemBgAnimation () {
      return this.redeemResult !== 0 ? 'bounce' : 'fadeInUp'
    },
    redeemContentAnimation () {
      // 兑换码内容 动画
      return this.redeemResult !== 0 ? 'slideOutDown' : 'fadeInUp'
    },
    redeemResAnimation () {
      // 兑换结果动画
      return this.redeemResult !== 0 ? 'slideInUp' : 'slideOutDown'
    },
    successText () {
      let num = this.couponList.length
      let price = num === 1 && this.couponList[0] ? this.getCouponPrice(this.couponList[0]) : ''
      return num > 1 ? sprintf(this.ngettext('恭喜你获得%s张优惠券，快去使用吧'), num) : sprintf(this.ngettext('恭喜你获得一张%s优惠券，快去使用吧'), price)
    }
  },
  methods: {
    getCouponPrice (coupon) {
      if (coupon.couponType === couponType.DISCOUNT) {
        return (100 - coupon.discount) + '%' + this.gettext('折')
      } else {
        return coupon.couponAmountSplit && coupon.couponAmountSplit.display
      }
    },
    lazyImgObj (value) {
      return {
        src: value
      }
    },
    showRedeemCode () {
      this.showCode = true
      trackEvent({
        eventId: 'sailing_c_x_prom_window_ck',
        eventLabel: '兑换码活动弹窗按钮点击',
        attrs: {
          activity_id: this.config.activityId
        }
      })
      // setTimeout(() => {
      this.exchangeCode()
      // }, 500)
    },
    async handleHide () {
      await this.setUserInfo()
      if (!this.showCode) {
        trackEvent({
          eventId: 'sailing_c_x_prom_window_close_ck',
          eventLabel: '兑换码活动弹窗关闭点击',
          attrs: {
            activity_id: this.config.activityId
          }
        })
      } else if (this.redeemResult === 0) {
        trackEvent({
          eventId: 'sailing_c_x_coupon_auto_window_close_ck',
          eventLabel: '兑换码活动弹窗—自动兑换页面关闭',
          attrs: {
            redeem_id: this.config.code,
            uid: this.userInfo.uid
          }
        })
      } else {
        trackEvent({
          eventId: 'sailing_c_x_redeem_result_window_close_ck',
          eventLabel: '兑换结果页关闭点击',
          attrs: {
            redeem_id: this.config.code,
            redeem_result_type: this.redeemResult,
            uid: this.userInfo.uid
          }
        })
      }
      this.$emit('onHide')
    },
    handleJump () {
      trackEvent({
        eventId: 'sailing_c_x_redeem_result_window_ck',
        eventLabel: '兑换结果页点击',
        attrs: {
          redeem_id: this.config.code,
          redeem_result_type: this.redeemResult,
          uid: this.userInfo.uid
        }
      })
      if (this.config.btnUrl) {
        this.SodaBridge('openPage', {
          target: 'blank',
          url: this.config.btnUrl
        })
        this.$emit('onHide')
      } else {
        this.$emit('onHide')
      }
    },
    async handleLogin () {
      this.$emit('onHide')
    },
    async exchangeCode () {
      let globalParamsData = await this.SodaBridge('getGlobalParams', 'badcase')
      const globalParams = globalParamsData.data
      let data = {
        ...globalParams,
        code: this.config.code,
        enterTime: new Date().getTime(),
        ua: window.navigator.userAgent
      }
      if (env.inNative) {
        if (env.inEmbedCustomerApp) {
          data.channelNo = 1
        } else if (env.inSoda) {
          data.channelNo = 2
        }
      }
      trackEvent({
        eventId: 'sailing_c_x_coupon_auto_window_sw',
        eventLabel: '兑换码活动弹窗按钮点击',
        attrs: {
          redeem_id: this.config.code,
          activity_id: this.config.activityId,
          uid: this.userInfo.uid
        }
      })
      let requestStart = new Date().getTime()
      try {
        let res = await Api.redeemCode(data)
        if (res.data.errno === 0) {
          this.handleSuccess(res.data.data)
        } else {
          this.handleError(res.data.errmsg)
        }
        this.trackApi(requestStart, res.data)
      } catch (err) {
        this.trackApi(requestStart, err)
        this.networkErr = true
        this.handleError(this.gettext('网络异常，请稍后再试'))
        console.warn(`exchangeCode`, err)
      }
    },
    async handleSuccess (data) {
      const rid = this.getRid(data.path)
      let globalParamsData = await this.SodaBridge('getGlobalParams', 'badcase')
      const globalParams = globalParamsData.data
      let params = {
        ...globalParams,
        rid: rid,
        enterTime: new Date().getTime(),
        ua: navigator.userAgent
      }
      if (env.inNative) {
        if (env.inEmbedCustomerApp) {
          params.channelNo = 1
        } else if (env.inSoda) {
          params.channelNo = 2
        }
      }
      let requestStart = new Date().getTime()
      try {
        let res = await Api.getRedeemResult(params)
        if (res.data.errno === 0) {
          this.couponList = res.data.data.couponList
          this.redeemResult = SUCC_CODE
          trackEvent({
            eventId: 'sailing_c_x_redeem_result_window_sw',
            eventLabel: '兑换结果页',
            attrs: {
              redeem_id: this.config.code,
              redeem_result_type: 1,
              uid: this.userInfo.uid
            }
          })
        } else {
          this.handleError(res.data.errmsg)
        }
        this.trackApi(requestStart, res.data)
      } catch (err) {
        this.trackApi(requestStart, err)
        this.networkErr = true
        this.handleError(this.gettext('网络异常，请稍后再试'))
        console.warn(`handleSuccess`, err)
      }
    },
    handleError (msg) {
      this.errResult = msg
      this.redeemResult = ERR_CODE
      trackEvent({
        eventId: 'sailing_c_x_redeem_result_window_sw',
        eventLabel: '兑换结果页',
        attrs: {
          redeem_id: this.config.code,
          redeem_result_type: 2,
          uid: this.userInfo.uid
        }
      })
    },
    getRid (path) {
      const ridIndex = path.indexOf('rid')
      const len = path.length
      if (ridIndex !== -1) {
        return path.slice(ridIndex, len).split('&')[0].split('=')[1]
      }
      return ''
    },
    tryRedeemCode () {
      this.networkErr = false
      this.redeemResult = 0
      this.showRedeemCode()
    },
    // api请求时间埋点
    trackApi (requestStart, responseData) {
      let requestEnd = new Date().getTime()
      trackEvent({
        eventId: 'sailing_act_x_api_request_timing',
        eventLabel: '兑换码弹窗',
        attrs: {
          window_type: 4,
          router: this.$route.fullPath,
          pageEnterTiming: window.performance.timing.navigationStart,
          ApiRequestStartTiming: requestStart,
          ApiRequestEndTiming: requestEnd,
          ApiRequestiming: requestEnd - requestStart,
          firstPageTiming: requestEnd - window.performance.timing.navigationStart,
          responseData: responseData
        }
      })
    }
  }
}
</script>
<style lang="scss">
@import "~@/assets/styles/main.scss";
@import "~@/assets/styles/var.scss";

.redeem-code {
  position: relative;
  height: 494px;
  width: 593px;
  color: #333333;
  .loading {
    &.primary {
      span:last-child{
        margin-right: 0px 
      }
      span:nth-child(1){
        animation-delay:0.43s
      }
      span:nth-child(2){
        animation-delay:0.66s
      }
      span:nth-child(3){
        animation-delay:0.89s
      }
      span { 
        background: #FAC7AA;
        animation: load 1.84s ease infinite;
      }
    }
    @keyframes load{
      0%{
          background: #FFFFFF;
          transform: scale(1.33);
      }
      100%{
          background: rgba(255, 255, 255, 0.5);
          transform: scale(1.0);
      }
    }
  }
  .img {
    background-size: 100% 100%;
    border-radius: 5px;
    width: 100%;
    display: block;
    height: 100%;
  }
  .redeem-bg-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: 0;
    overflow: hidden;
  }
  .redeem-red-front {
    position: absolute;
    bottom: 0;
    z-index: 3;
    width: 100%;
    display: block;
    height: 227px;
    text-align: center;
    background-image: url('~@/assets/images/banner/redeem_red_front_bg@2x.png');
    background-size: 100% 100%;
    p {
      margin-top: 99px;
      font-size: 36px;
      color: #ffffff;
      text-align: center;
    }
    .btn {
      position: absolute;
      top: 117px;
      left: 0;
      right: 0;
      width: 484px;
      height: 80px;
      margin: 0 auto;
      line-height: 80px;
      @include button-font-color();
      font-size: 36px;
      border: none;
      @include background-gradient(90deg, 39%, 99%);
      box-shadow: 0 2px 24px 0 #D51F30;
      border-radius: 8px;
      padding: 0;
    }
  }
  .redeem-red-back {
    position: absolute;
    bottom: 131px;
    width: 100%;
    display: block;
    margin-bottom: 131px;
    box-sizing: content-box;
    bottom: 0;
    height: 124px;
    background-image: url('~@/assets/images/banner/redeem_red_back_bg@2x.png');
    background-size: 100% 100%;
  }
  .redeem-content, .redeem-suc-content, .redeem-err-content {
    margin: 0 auto;
    z-index: 1;
    position: absolute;
    left: 0;
    right: 0;
    width: 536px;
    display: block;
    height: 100%;
    padding-bottom: 50px;
    box-sizing: border-box;
    background-image: url('~@/assets/images/banner/redeem_bg@2x.png');
    background-size: 100% 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    .label {
      margin-top: 84px;
      font-size: 40px;
    }
    .code {
      margin-top: 60px;
      font-size: 56px;
    }
  }
  .redeem-suc-content {
    background-image: url('~@/assets/images/banner/redeem_suc_bg@2x.png');
    .title {
      font-size: 40px;
      margin-top: 29px;
    }
    .label {
      font-size: 32px;
      line-height: 40px;
      margin-top: 10px;
      padding: 0 45px;
    }
  }
  .redeem-err-content {
    // background-image: url('../../../assets/images/banner/redeem_suc_bg@2x.png');
    .title {
      font-size: 40px;
      margin-top: 29px;
    }
    .label {
      font-size: 32px;
      line-height: 40px;
      margin-top: 10px;
      padding: 0 45px;
    }
    &.network-err {
      .label {
        font-size: 32px;
        color: #666666;
        line-height: 40px;
        margin-top: 132px;
        padding: 0 45px;
      }
    }
  }
  .success-icon, .error-icon {
    height: 72px;
    width: 72px;
    background-image: url('~@/assets/images/banner/redeem_suc_icon@2x.png');
    background-size: 100% 100%;
    margin-top: 62px;
  }
  .error-icon {
    background-image: url('~@/assets/images/banner/redeem_err_icon@2x.png');
  }
  .close-btn {
    position: absolute;
    bottom: -114px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    img {
      width: 60px;
      height: 60px;
    }
  }
  .animated {
    animation-duration: 0.5s;
    animation-fill-mode: both;
  }
  .animated-content {
    animation-duration: 0.5s;
    animation-fill-mode: both;
  }
  .animated-res {
    animation-duration: 0.7s;
    animation-delay: 0.2s;
    animation-fill-mode: both;
  }

  .fadeInUp {
    animation-name: fadeInUp;
  }
  .slideInUp {
    animation-name: slideInUp;
  }
  .bounce {
    animation-name: bounce;
    transform-origin: center bottom;
  }
  .slideOutDown {
    -webkit-animation-name: slideOutDown;
    animation-name: slideOutDown;
  }
  .fadeIn {
    animation-name: fadeIn;
  }
  .fadeOut {
    animation-name: fadeOut;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translate3d(0, 30%, 0);
      // visibility: visible;
    }
    70% {
      opacity: 1;
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }
  
  @keyframes slideInUp {
    from {
      // opacity: 0;
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      transform: translate3d(0, 70%, 0);
      // visibility: visible;
    }

    to {
      // opacity: 1;
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      transform: translate3d(0, 0, 0);
    }
  }
  

  @keyframes bounce {
    from,
    20%,
    80%,
    to {
      animation-timing-function: ease;
      transform: translate3d(0, 0, 0);
    }

    40% {
      animation-timing-function: ease;
      transform: translate3d(0, 10%, 0);
    }
  }

  @-webkit-keyframes slideOutDown {
    from {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }

    to {
      visibility: hidden;
      -webkit-transform: translate3d(0, 100%, 0);
      transform: translate3d(0, 100%, 0);
    }
  }

  @keyframes slideOutDown {
    from {
      transform: translate3d(0, 0, 0);
    }

    to {
      visibility: hidden;
      transform: translate3d(0, 100%, 0);
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
  @keyframes fadeOut {
    from {
      opacity: 1;
      visibility: visible;
    }

    to {
      opacity: 0;
    }
  }

}
</style>